﻿import IEntityResult from "../interfaces/IEntityResult";
import {PermitEntityResult, PermitFullEntityResult} from "../types/PermitEntityResult";

export function findEntityById<TId, T extends IEntityResult<TId>>(history: T[], id: TId, defaultFactory: (id: TId) => T): T {
	return history.find(permit => permit.id === id) ?? defaultFactory(id);
}

export function toFullEntityResult<TId, T extends IEntityResult<TId>>(history: T[], entityResult: PermitEntityResult<TId>, defaultFactory: (id: TId) => T): PermitFullEntityResult<TId, T> {
	const result = findEntityById<TId, T>(history, entityResult.id, defaultFactory);
	return {
		id: entityResult.id,
		operation: entityResult.operation,
		replaces: entityResult.replaces,
		status: entityResult.status,
		statusReason: entityResult.statusReason,
		entity: result
	}
}
